class ReadMore extends HTMLElement {
  constructor() {
    super();
    this.$text = null;
    this.callback = null;
  }

  connectedCallback() {
    this.$text = this.querySelector('[data-read]');
    const content = this.$text.textContent;
    const style = window.getComputedStyle(this.$text);
    const lineHeight = parseInt(style.lineHeight, 10);
    const maxHeight = lineHeight * 2;

    console.log(lineHeight, maxHeight);
    if (this.$text.scrollHeight <= maxHeight) return this.destroy();
    this.initialize();
  }

  initialize() {
    if (isNullOrUndefined(this.$text)) return;

    this.$text.addEventListener('click', this.toggleRead.bind(this));
  }

  destroy() {
    if (isNullOrUndefined(this.$text)) return;

    this.$text.removeAttribute('data-read');
  }

  toggleRead() {
    if (isNullOrUndefined(this.$text)) return;

    const currentState = this.$text.dataset.read;
    this.$text.dataset.read = currentState === 'less' ? 'more' : 'less';

    if (typeof this.callback === 'function') {
      this.callback();
    }
  }
}

customElements.define('read-more', ReadMore);
